(function ($) {
    "use strict";

    var SELECTOR = '[data-autocomplete-address]';
    var FIELDSET_SELECTOR = '[data-tenant-address]';

    var $body = $('body');

    window.AutocompleteAddress = {};

    window.AutocompleteAddress.elements = [];

    window.AutocompleteAddress.getElementByInstance = function (instance) {
        var element;

        $.each(window.AutocompleteAddress.elements, function () {
            if ($(this).data('autocomplete-address.instance') === instance) {
                element = this;
                return false;
            }
        });

        return element;
    }

    window.AutocompleteAddress.onPlaceChanged = function () {
        var instance = this,
            place = instance.getPlace(),
            element = window.AutocompleteAddress.getElementByInstance(instance),
            $element = $(element),
            namespace = $element.attr('data-autocomplete-address')
        ;

        if (! place.address_components) {
            return;
        }

        var componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            country: 'long_name',
            postal_code: 'short_name',
            administrative_area_level_1: 'long_name'
        };

        var componentData = {};

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (componentForm[addressType]) {
                componentData[addressType] = place.address_components[i][componentForm[addressType]];
            }

            if (addressType === 'country') {
                componentData.country_iso = place.address_components[i].short_name;
            }

            if (addressType === 'administrative_area_level_1') {
                componentData.state_iso = place.address_components[i].short_name;
            }
        }

        var city;
        var state;
        var country;
        var stateIso;
        var countryIso;
        var postalCode;
        var address = '';
        var addressNumber;
        var addressStreet;
        var fullAddress = '';
        var name = place.name || '';

        if (componentData.street_number) {
            addressNumber = componentData.street_number;
            address += addressNumber;
        }

        if (componentData.route) {
            addressStreet = componentData.route;
            address += ' ' + addressStreet;
        }

        fullAddress = address;

        if (componentData.locality) {
            city = componentData.locality;
            fullAddress += ', ' + city;
        }

        if (componentData.postal_code) {
            postalCode = componentData.postal_code;
            fullAddress += ', ' + postalCode;
        }

        if (componentData.administrative_area_level_1) {
            state = componentData.administrative_area_level_1;
            fullAddress += ', ' + state;
        }

        if (componentData.state_iso) {
            stateIso = componentData.state_iso;
        }

        if (componentData.country) {
            country = componentData.country;
            fullAddress += ', ' + country;
        }

        if (componentData.country_iso) {
            countryIso = componentData.country_iso;
        }

        $body.find('[data-autocomplete-address-address-number="' + namespace + '"]').val(addressNumber).trigger('change');
        $body.find('[data-autocomplete-address-address-street="' + namespace + '"]').val(addressStreet).trigger('change');
        $body.find('[data-autocomplete-address-country-iso="' + namespace + '"]').val(countryIso).trigger('change');
        $body.find('[data-autocomplete-address-postal-code="' + namespace + '"]').val(postalCode).trigger('change');
        $body.find('[data-autocomplete-address-state-iso="' + namespace + '"]').val(stateIso).trigger('change');
        $body.find('[data-autocomplete-address-full="' + namespace + '"]').val(fullAddress).trigger('change');
        $body.find('[data-autocomplete-address-address="' + namespace + '"]').val(address).trigger('change');
        $body.find('[data-autocomplete-address-country="' + namespace + '"]').val(country).trigger('change');
        $body.find('[data-autocomplete-address-state="' + namespace + '"]').val(state).trigger('change');
        $body.find('[data-autocomplete-address-city="' + namespace + '"]').val(city).trigger('change');
        $body.find('[data-autocomplete-address-focus="' + namespace + '"]').select();
        $body.find('[data-autocomplete-address-name="' + namespace + '"]').val(name).trigger('change');

        $element.val('');
        $body.trigger('autocomplete-address.place-changed', [$element.closest(FIELDSET_SELECTOR)]);
    };

    window.AutocompleteAddress.onInitialize = function (event) {
        var $element = $(this);

        if ($element.data('autocomplete-address.initialized')) {
            return;
        }

        $element.data('autocomplete-address.initialized');

        var instance = new window.google.maps.places.Autocomplete(this, {
            // Google Maps API does not allow multiple types in a single request.
            // Instead, you need to omit the types property so that the autocomplete
            // covers both addresses and establishments.
            // types: ['address']
        });

        if ($element.data('autocomplete-address-restrictions')) {
            instance.setComponentRestrictions($element.data('autocomplete-address-restrictions'));
        }

        instance.setFields(['address_component', 'geometry', 'name']);

        instance.addListener('place_changed', window.AutocompleteAddress.onPlaceChanged);

        $element.prop('disabled', false);
        $element.val('');

        $element.data('autocomplete-address.instance', instance);
        window.AutocompleteAddress.elements.push(this);
    };

    window.AutocompleteAddress.onKeypress = function (event) {
        var keyPressed = event.keyCode || event.which;
        if (keyPressed === 13) {
            event.preventDefault();
            return false;
        }
    };

    window.AutocompleteAddress.onFocus = function (event) {
        event.preventDefault();
        var $this = $(this);
        $this.attr('placeholder', $this.attr('data-focus-placeholder'));
    };

    window.AutocompleteAddress.onBlur = function (event) {
        event.preventDefault();
        var $this = $(this);
        $this.attr('placeholder', $this.data('placeholder'));
    };

    window.AutocompleteAddress.onCountryIsoChange = function () {
        var $element = $(this);
        var $fieldset = $element.closest(FIELDSET_SELECTOR);
        var $international = $fieldset.find('[data-international-checkbox]');

        if ($element.val() !== '') {
            var internationalMustBeChecked = $element.val() !== 'CA';
            if ($international.prop('checked') !== internationalMustBeChecked) {
                $international.trigger('click');
            }
        }
    }

    $(document).ready(function () {
        $body.on('initialize.autocomplete-address', SELECTOR, window.AutocompleteAddress.onInitialize);
        $body.on('keypress.autocomplete-address', SELECTOR, window.AutocompleteAddress.onKeypress);
        $body.on('focus.autocomplete-address', SELECTOR, window.AutocompleteAddress.onFocus);
        $body.on('blur.autocomplete-address', SELECTOR, window.AutocompleteAddress.onBlur);

        $body.on(
            'change.autocomplete-address',
            FIELDSET_SELECTOR + ' [data-autocomplete-address-country-iso]',
            window.AutocompleteAddress.onCountryIsoChange
        );

        $body.find(SELECTOR).each(function () {
            var $this = $(this);
            $this.data('placeholder', $this.attr('placeholder'));
        });

        $(window).bind('google-map-ready.autocomplete-address', function () {
            $body.find(SELECTOR).trigger('initialize.autocomplete-address');
        });
    });

})(require('jquery'));
